import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';

import { userApi } from 'src/Services/API';
import { CreatePushSubscriptionDto } from 'src/Services/API/generated';

export const useSavePushSubscription = (
  options?: UseMutationOptions<void, unknown, CreatePushSubscriptionDto>
) => {
  const queryClient = useQueryClient();

  return useMutation<void, unknown, CreatePushSubscriptionDto>(
    ['save-push-subscription'],
    async payload => {
      await userApi.userControllerSavePushSubscription(payload);
    },
    {
      ...options,
      onSuccess: (data, variables, context) => {
        queryClient.invalidateQueries(['user-profile']);

        if (options?.onSuccess) {
          options.onSuccess(data, variables, context);
        }
      },
    }
  );
};
